import React from "react";
import PropTypes from "prop-types";
import RTPMIcon from "../assets/images/MyHR-Icon.png";

const MyHealthRecordBtn = props => {


    const openHealthRecord = () => {
        window.open('https://provider.ehealth.gov.au/login.html', "_blank");
    }


    return (
        <>
            <img src={RTPMIcon} alt="RTPM-Icon" className={`rtpm-icon-btn ${props.className}`} onClick={openHealthRecord} />
        </>
    )
};

export default MyHealthRecordBtn;

MyHealthRecordBtn.defaultProps = {
    className: ""
};

MyHealthRecordBtn.prototype = {
    className: PropTypes.string
};
